namespace RioERP.Orders {
    export interface TeacherPaymentsRow {
        Id?: number;
        TeacherId?: number;
        PaymentDate?: string;
        PaidAmount?: number;
        PaymentMode?: Web.Enums.PaymentMode;
        Remark?: string;
        PaymentRefNo?: string;
        BankName?: string;
        Comment?: string;
        ReceiptNo?: string;
        IsActive?: number;
        TeacherName?: string;
        TeacherDescription?: string;
        TeacherEmail?: string;
        TeacherAlternateEmail?: string;
        TeacherMobile?: string;
        TeacherAlternateMobile?: string;
        TeacherAddress?: string;
        TeacherCity?: string;
        TeacherStateId?: number;
        TeacherUserId?: number;
        TeacherGstin?: string;
        TeacherPan?: string;
        TeacherGstCertificate?: string;
        TeacherBankName?: string;
        TeacherBankAccountType?: number;
        TeacherBankAccountName?: string;
        TeacherBankAccountNo?: string;
        TeacherBankIfscCode?: string;
        TeacherPincode?: number;
        TeacherIsActive?: boolean;
        TeacherInsertUserId?: number;
        TeacherInsertDate?: string;
        TeacherUpdateUserId?: number;
        TeacherUpdateDate?: string;
        RowIds?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace TeacherPaymentsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Remark';
        export const localTextPrefix = 'Orders.TeacherPayments';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            TeacherId = "TeacherId",
            PaymentDate = "PaymentDate",
            PaidAmount = "PaidAmount",
            PaymentMode = "PaymentMode",
            Remark = "Remark",
            PaymentRefNo = "PaymentRefNo",
            BankName = "BankName",
            Comment = "Comment",
            ReceiptNo = "ReceiptNo",
            IsActive = "IsActive",
            TeacherName = "TeacherName",
            TeacherDescription = "TeacherDescription",
            TeacherEmail = "TeacherEmail",
            TeacherAlternateEmail = "TeacherAlternateEmail",
            TeacherMobile = "TeacherMobile",
            TeacherAlternateMobile = "TeacherAlternateMobile",
            TeacherAddress = "TeacherAddress",
            TeacherCity = "TeacherCity",
            TeacherStateId = "TeacherStateId",
            TeacherUserId = "TeacherUserId",
            TeacherGstin = "TeacherGstin",
            TeacherPan = "TeacherPan",
            TeacherGstCertificate = "TeacherGstCertificate",
            TeacherBankName = "TeacherBankName",
            TeacherBankAccountType = "TeacherBankAccountType",
            TeacherBankAccountName = "TeacherBankAccountName",
            TeacherBankAccountNo = "TeacherBankAccountNo",
            TeacherBankIfscCode = "TeacherBankIfscCode",
            TeacherPincode = "TeacherPincode",
            TeacherIsActive = "TeacherIsActive",
            TeacherInsertUserId = "TeacherInsertUserId",
            TeacherInsertDate = "TeacherInsertDate",
            TeacherUpdateUserId = "TeacherUpdateUserId",
            TeacherUpdateDate = "TeacherUpdateDate",
            RowIds = "RowIds",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
